// Smart Sash Admin Panel - Axios HTTP Client
// Configured Axios instance with base settings

import axios, { AxiosInstance, CreateAxiosDefaults } from 'axios';

/**
 * Base Axios configuration
 */
const config: CreateAxiosDefaults = {
  baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000/api',
  timeout: 30000, // 30 seconds
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  // Auth cookies are HttpOnly and set by the server — the browser sends them automatically.
  withCredentials: true,
};

/**
 * Axios instance for API calls
 */
export const axiosClient: AxiosInstance = axios.create(config);

/**
 * Get current base URL
 */
export const getBaseURL = (): string => {
  return axiosClient.defaults.baseURL || '';
};

/**
 * Update base URL (useful for environment switching)
 */
export const setBaseURL = (url: string): void => {
  axiosClient.defaults.baseURL = url;
};

/**
 * Response interceptor: unwrap v2 API {success, data, error} envelope.
 * If the response body has a `success` field, extract `data` or reject with `error`.
 */
axiosClient.interceptors.response.use(
  (response) => {
    const body = response.data;
    if (body && typeof body === 'object' && 'success' in body) {
      if (body.success === false) {
        return Promise.reject(new Error(body.error || 'API request failed'));
      }
      response.data = body.data;
    }
    return response;
  },
  (error) => Promise.reject(error)
);

export default axiosClient;
